import {PersonEpic} from 'module/Person/epic/PersonEpic'
import {Module} from 'module/Module'
import {PersonReducerNS} from 'module/Person/reducer/PersonReducer'
import {PropID} from 'module/Properties/enum/PropID'
import {TopNavBarPersonButtonColorByVisibilityEpic} from 'module/Person/epic/TopNavBarPersonButtonColorByVisibilityEpic'

export const PersonModuleWithoutInit: Module = {
	reducerNS: PersonReducerNS,
	epics: [
		PersonEpic,
		TopNavBarPersonButtonColorByVisibilityEpic,
	],
	properties: [PropID.evoApps_personListTemplate],
}